import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Select } from '@telus-uds/components-web';

import request from '../../../../../utils/request';
import { CONSTANT } from '../../../../../utils/constant';

const Role = ({ fieldData, setFieldData }) => {
  const [rolesList, setRolesList] = useState([]);
  const {
    KEYS: {
      ROLES: {
        ADMIN_TIME_TRACKING,
        MANAGER_TIME_TRACKING,
        TEAM_MEMBER_TIME_TRACKING
      }
    }
  } = CONSTANT;

  useEffect(() => {
    (async () => {
      const result = await request.get('/roles');
      setRolesList(result.data.roles);
    })();
  }, []);

  // Separate roles into two groups
  const mysofRoles = rolesList.filter(
    item =>
      ![
        ADMIN_TIME_TRACKING,
        MANAGER_TIME_TRACKING,
        TEAM_MEMBER_TIME_TRACKING
      ].includes(item.name)
  );

  const timeTrackingRoles = rolesList.filter(item =>
    [
      ADMIN_TIME_TRACKING,
      MANAGER_TIME_TRACKING,
      TEAM_MEMBER_TIME_TRACKING
    ].includes(item.name)
  );

  return (
    <Select
      label="User Role *"
      placeholder="Please select..."
      value={fieldData.role}
      onChange={(value) =>
        setFieldData(previousValue => ({ ...previousValue, role: value }))
      }
    >
      {/* MySOF Roles */}
      {mysofRoles.length > 0 && (
        <>
          <Select.Item value="" disabled>
            ──── MySOF ────
          </Select.Item>
          {mysofRoles.map(role => (
            <Select.Item key={role.name} value={role.name}>
              {role.description}
            </Select.Item>
          ))}
        </>
      )}
      
      {/* Time Tracking Tool Roles */}
      {timeTrackingRoles.length > 0 && (
        <>
          <Select.Item value="" disabled>
            ──── Time Tracking Tool ────
          </Select.Item>
          {timeTrackingRoles.map(role => (
            <Select.Item key={role.name} value={role.name}>
              {role.description}
            </Select.Item>
          ))}
        </>
      )}
    </Select>
  );
};

Role.propTypes = {
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Role;
